import styled from 'styled-components';

const blue = '#0b1f82';
const blueDark = '#020f4d';
const gray = '#a5a5a5';
const gray2 = '#d6d6d6';
const label = '#6f6f6f';

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
`;

export const HeaderLeft = styled.div`
    flex: 1;
    min-width: 280px;
`;

export const HeaderRight = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-end;
`;

export const HeaderActionsRow = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
`;

export const Title = styled.p`
    font-family: "Open Sans", sans-serif;
    color: ${blue};
    font-size: 22px;
    font-weight: 700;
    margin: 0;
`;

export const ExecToggle = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    cursor: pointer;
    color: ${blue};
    font-family: "Open Sans", sans-serif;
    font-size: 13px;
    font-weight: 600;
    padding: 6px 0;

    .exec-chevron {
        transition: transform 0.2s;
        transform: ${(props) => (props.open ? 'rotate(180deg)' : 'none')};
        font-size: 18px;
    }
`;

export const ExecPanel = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 32px;
    background: #f9fafc;
    border: 1px solid ${gray2};
    border-radius: 8px;
    padding: 16px;
    margin-top: 8px;
    max-width: 620px;
`;

export const ExecItem = styled.div`
    .exec-l {
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        color: ${label};
        margin-bottom: 2px;
    }
    .exec-v {
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        color: #333;
        font-weight: 600;
    }
`;

export const Btn = styled.button`
    font-family: "Open Sans", sans-serif;
    border-radius: 30px;
    padding: 9px 20px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    color: ${blue};
    border: 2px solid ${blue};

    &:hover {
        background: #f0f8ff;
    }
`;

export const SegControl = styled.div`
    display: inline-flex;
    background: #f0f0f0;
    border-radius: 22px;
    padding: 3px;
`;

export const SegBtn = styled.button`
    font-family: "Open Sans", sans-serif;
    border: none;
    border-radius: 20px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    background: ${(props) => (props.active ? '#fff' : 'transparent')};
    color: ${(props) => (props.active ? blue : label)};
    box-shadow: ${(props) => (props.active ? '0 1px 4px rgba(0,0,0,.13)' : 'none')};
`;

export const SegNote = styled.span`
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    color: ${label};

    b {
        color: ${blue};
    }
`;

export const Report = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Grid4 = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const Grid2 = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

export const Card = styled.div`
    background: #fff;
    border-radius: 8px;
    padding: 18px;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
`;

export const Kpi = styled(Card)`
    .kpi-n {
        font-family: "Open Sans", sans-serif;
        font-size: 28px;
        font-weight: 700;
        color: ${blue};
    }
    .kpi-l {
        font-family: "Open Sans", sans-serif;
        font-size: 13px;
        color: ${label};
        margin-top: 4px;
    }
    .kpi-delta {
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        margin-top: 2px;
    }
    .kpi-delta.up { color: #297835; }
    .kpi-delta.down { color: #d91a1a; }
    .kpi-delta.flat { color: ${label}; }
`;

export const CardTitle = styled.div`
    font-family: "Open Sans", sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: ${blue};
    margin-bottom: 14px;

    .muted {
        font-weight: 400;
        color: ${label};
        font-size: 13px;
        margin-left: 6px;
    }
`;

export const CmpCol = styled.div`
    .cmp-lab {
        font-family: "Open Sans", sans-serif;
        font-size: 13px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
    }
    .cmp-vals {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: "Open Sans", sans-serif;
        font-size: 13px;
        margin-bottom: 6px;
    }
    .cmp-a { color: ${label}; }
    .cmp-n { color: ${blue}; font-weight: 700; }
    .cmpbar {
        height: 10px;
        background: #eef0f6;
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 6px;
    }
    .cmpbar i { display: block; height: 100%; border-radius: 5px; }
    .cmpbar i.a { background: ${gray}; }
    .cmpbar i.n { background: ${blue}; }
    .cmp-delta {
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        margin-top: 4px;
    }
    .cmp-delta.up { color: #297835; }
    .cmp-delta.down { color: #d91a1a; }
    .cmp-delta.flat { color: ${label}; }
`;

export const VariationGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

export const VarItem = styled.div`
    border: 1px solid ${gray2};
    border-radius: 8px;
    padding: 12px 14px;

    .var-status {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: "Open Sans", sans-serif;
        font-size: 13px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
    }
    .var-status i.dot {
        width: 10px;
        height: 10px;
        border-radius: 3px;
        display: inline-block;
    }
    .var-metric {
        display: flex;
        justify-content: space-between;
        font-family: "Open Sans", sans-serif;
        font-size: 13px;
        margin-top: 3px;
    }
    .var-metric .var-k { color: ${label}; }
    .var-metric .var-v { font-weight: 700; }
    .var-metric .var-v.up { color: #297835; }
    .var-metric .var-v.down { color: #d91a1a; }
    .var-metric .var-v.flat { color: ${label}; }
`;

export const ChartLegend = styled.div`
    display: flex;
    gap: 18px;
    justify-content: center;
    margin-top: 10px;
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    color: #333;

    span {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }
    i.sq {
        width: 12px;
        height: 12px;
        border-radius: 3px;
        display: inline-block;
    }
    i.ll {
        width: 18px;
        height: 0;
        display: inline-block;
        border-top: 3px solid ${gray};
    }
    i.ll.dashed { border-top-style: dashed; }
    i.ll.solid { border-top: 3px solid ${blue}; }
`;

export const LoadingWrap = styled.div`
    display: flex;
    height: 55vh;
    align-items: center;
    justify-content: center;
`;

export { blue, blueDark, gray, gray2, label };
